
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-generals-20d-2015/espanya",
      function () {
        return require("private-next-pages/3catinfo/eleccions-generals-20d-2015/espanya/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-generals-20d-2015/espanya"])
      });
    }
  